import React from 'react';
import { Box, Typography } from '@mui/material';

const Payments: React.FC = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" component="h1" fontWeight={600} sx={{ mb: 2 }}>
        Payments & Invoices
      </Typography>
      <Typography variant="body2" color="text.secondary">
        View payment status and request payment (Principal/Admin only).
      </Typography>
    </Box>
  );
};

export default Payments;
